/**
 * Renders templates/page.sign-categories.liquid (list) and
 * templates/page.sign-category.liquid (detail) from window.SignCategories,
 * and wires up the shared interactions (variant gallery modal, quote popup,
 * variant filters).
 */
(function () {
  var DATA = window.SignCategories;
  if (!DATA) return;

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function icon(name) {
    return DATA.ICONS[name] || '';
  }

  function svg(name) {
    return '<svg viewBox="0 0 24 24">' + icon(name) + '</svg>';
  }

  function heading(prefix, emphasis) {
    return esc(prefix) + ' <em>' + esc(emphasis) + '</em>';
  }

  function normalizeSignName(str) {
    return (str || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  // ───────────────────────── Skeleton loading helpers ─────────────────────────

  var SKELETON_STYLE_ID = 'sign-categories-skeleton-styles';

  function injectSkeletonStyles() {
    if (document.getElementById(SKELETON_STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = SKELETON_STYLE_ID;
    style.textContent =
      '@keyframes skeletonShimmer{0%{background-position:-400px 0}100%{background-position:400px 0}}' +
      '.skeleton-block{background:linear-gradient(90deg,#eceff1 25%,#f6f7f8 37%,#eceff1 63%);' +
      'background-size:800px 100%;animation:skeletonShimmer 1.4s ease infinite;border-radius:8px;' +
      'display:block;color:transparent!important;}' +
      '.skeleton-row{pointer-events:none;}' +
      '.type-row-img.skeleton-block{aspect-ratio:4/3;width:100%;height:auto;}' +
      '.skeleton-row .type-row-features li.skeleton-block{height:16px;margin-bottom:10px;list-style:none;}' +
      '.skeleton-row .type-row-btn.skeleton-block{border:none;}';
    document.head.appendChild(style);
  }

  function preloadImage(src) {
    return new Promise(function (resolve) {
      if (!src) { resolve(); return; }
      var img = new Image();
      img.onload = function () { resolve(); };
      img.onerror = function () { resolve(); }; // don't block the swap on a broken image
      img.src = src;
    });
  }

  // Resolve once all images are loaded, or after `timeoutMs`, whichever is first,
  // so a slow/broken image never leaves the skeleton up indefinitely.
  function preloadImagesWithTimeout(srcs, timeoutMs) {
    var loadAll = Promise.all(srcs.map(preloadImage));
    var timeout = new Promise(function (resolve) {
      setTimeout(resolve, timeoutMs);
    });
    return Promise.race([loadAll, timeout]);
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  // ───────────────────────── Detail page block builders ─────────────────────────

  function buildTrustBar() {
    var items = DATA.TRUST_ITEMS.map(function (t) {
      return '<div class="trust-item">' + svg(t.icon) + '<span>' + t.html + '</span></div>';
    }).join('');
    return '<div class="trust-bar trust-bar-merged"><div class="trust-inner">' + items + '</div></div>';
  }

  function buildHero(cat) {
    var pills = cat.hero.pills
      .map(function (p) {
        return '<span class="cat-pill">' + svg('check') + esc(p) + '</span>';
      })
      .join('');
    var secondaryLabel = cat.hero.secondaryCtaLabel || 'All Sign Types';
    return (
      '<section class="cat-hero"><div class="cat-hero-inner">' +
      '<div class="cat-hero-text">' +
      '<div class="cat-breadcrumb"><a href="/">Home</a>' +
      svg('chevronRight') +
      '<a href="/pages/sign-categories">Sign Types</a>' +
      svg('chevronRight') +
      '<span class="current">' + esc(cat.breadcrumbLabel) + '</span></div>' +
      '<h1>' + heading(cat.hero.title, cat.hero.emphasis) + '</h1>' +
      '<p class="cat-hero-desc">' + esc(cat.hero.desc) + '</p>' +
      '<div class="cat-pills">' + pills + '</div>' +
      '<div class="cat-hero-ctas">' +
      '<a href="/pages/signage" class="btn-primary">Get Your Free Mockup' + svg('arrowRight') + '</a>' +
      '<a href="/pages/sign-categories" class="btn-ghost">' + esc(secondaryLabel) + svg('chevronRight') + '</a>' +
      '</div></div>' +
      '<div class="cat-hero-visual"><img src="' + cat.hero.image.src + '" alt="' + esc(cat.hero.image.alt) + '" loading="eager"></div>' +
      '</div>' +
      buildTrustBar() +
      '</section>'
    );
  }

  function buildStats(cat) {
    var stats = cat.stats
      .map(function (s) {
        return (
          '<div class="cat-stat"><div class="cat-stat-icon">' + svg(s.icon) + '</div>' +
          '<div class="cat-stat-meta"><span class="cat-stat-num">' + esc(s.num) + '</span>' +
          '<span class="cat-stat-lab">' + esc(s.label) + '</span></div></div>'
        );
      })
      .join('');
    return '<div class="cat-stats"><div class="cat-stats-inner">' + stats + '</div></div>';
  }

  function buildVarCard(item) {
    var tags = item.tags.map(function (t) { return '<span class="var-tag">' + esc(t) + '</span>'; }).join('');
    var attrs = item.placement ? ' data-placement="' + esc(item.placement) + '"' : '';
    return (
      '<article class="var-card"' + attrs + '>' +
      '<div class="var-card-img"><img src="' + item.img + '" alt="' + esc(item.alt) + '" loading="lazy"></div>' +
      '<div class="var-card-body"><h3>' + esc(item.title) + '</h3><p>' + esc(item.desc) + '</p>' +
      '<div class="var-tags">' + tags + '</div>' +
      '<div class="var-card-actions">' +
      '<button type="button" class="var-card-btn var-card-btn-outline var-card-gallery">View more images</button>' +
      '<button type="button" class="var-card-btn var-card-quote">Get a Quote</button>' +
      '</div></div></article>'
    );
  }

  function buildVariants(cat) {
    var v = cat.variants;
    var filters = '';
    if (v.filters) {
      filters =
        '<div class="cat-var-filters">' +
        '<button type="button" class="cat-var-filter active" data-filter="all">All</button>' +
        v.filters
          .map(function (label, i) {
            var filterValue = i === 0 ? 'interior' : 'exterior';
            return (
              '<button type="button" class="cat-var-filter" data-filter="' + filterValue + '">' +
              esc(label) +
              '</button>'
            );
          })
          .join('') +
        '</div>';
    }
    var cards = v.items.map(buildVarCard).join('');
    return (
      '<section class="cat-variants"><div class="sec-head">' +
      '<span class="sec-label">' + esc(v.label) + '</span>' +
      '<h2 class="sec-h">' + heading(v.heading, v.emphasis) + '</h2>' +
      '<p class="sec-sub">' + esc(v.sub) + '</p></div>' +
      filters +
      '<div class="cat-variants-grid">' + cards + '</div></section>'
    );
  }

  // ─────────── "Why Signs.inc" block (mirrors sections/nt-home-why-us-v1.liquid) ───────────

  var WHY_US_STYLE_ID = 'sign-categories-why-us-styles';

  var WHY_US_ITEMS = [
    { icon: '<path d="M4 4h16v16H4z"/><path d="M9 9h6M9 13h4"/>', title: 'Unlimited Revisions', desc: 'Refine until it\'s right. <span>No round limits.</span>' },
    { icon: '<circle cx="12" cy="12" r="9"/><path d="M8 12l2.5 2.5L16 9"/>', title: 'UL 48 Certified', desc: '<span>Certified power supplies</span> and commercial-grade LEDs.' },
    { icon: '<circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M4.22 4.22l2.12 2.12M17.66 17.66l2.12 2.12M2 12h3M19 12h3M4.22 19.78l2.12-2.12M17.66 6.34l2.12-2.12"/>', title: 'Custom Colors', desc: 'Match any <span>Pantone, hex, or RAL</span> code exactly.' },
    { icon: '<rect x="3" y="3" width="18" height="18" rx="3"/><path d="M8 12h8M12 8v8"/>', title: 'Custom Material', desc: 'Acrylic, aluminum, wood, steel. <span>You choose.</span>' },
    { icon: '<rect x="2" y="4" width="20" height="16" rx="2"/><path d="M7 9h10M7 13h6"/>', title: 'Unlimited Mockups', desc: 'See it <span>before production</span>. As many views as needed.' },
    { icon: '<path d="M22 16.92V19a2 2 0 01-2.18 2A19.79 19.79 0 013 5.18 2 2 0 015 3h2.09a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 10.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 17z"/>', title: '24/7 Support', desc: '<span>Real people</span>, any time — chat, email, or phone.' },
    { icon: '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>', title: '2-Year Warranty', desc: 'Something fails? <span>We fix it</span>, no questions.' },
    { icon: '<path d="M20 7H4a2 2 0 00-2 2v6a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2z"/><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/>', title: 'Wholesale Pricing', desc: '<span>Factory-direct rates</span> on every volume order.' },
  ];

  function injectWhyUsStyles() {
    if (document.getElementById(WHY_US_STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = WHY_US_STYLE_ID;
    style.textContent =
      '.nt-home-why-us-v1 .why-grid{max-width:1100px;margin:0 auto;display:grid;grid-template-columns:repeat(4,1fr);gap:16px;}' +
      '.nt-home-why-us-v1 .why-card{background:#fff;border:1px solid #e5e7eb;border-radius:12px;padding:24px 20px 26px;position:relative;overflow:hidden;transition:box-shadow .22s ease,border-color .22s ease;}' +
      '.nt-home-why-us-v1 .why-card::after{content:"";position:absolute;left:0;top:0;bottom:0;width:3px;background:var(--gold);transform:scaleY(0);transform-origin:bottom;transition:transform .25s ease;border-radius:3px 0 0 3px;}' +
      '.nt-home-why-us-v1 .why-card:hover{box-shadow:0 6px 24px rgba(1,136,204,.10);border-color:var(--gold-line);}' +
      '.nt-home-why-us-v1 .why-card:hover::after{transform:scaleY(1);}' +
      '.nt-home-why-us-v1 .why-card::before{display:none;}' +
      '.nt-home-why-us-v1 .why-card-layout{display:flex;flex-direction:column;align-items:flex-start;gap:0;}' +
      '.nt-home-why-us-v1 .why-icon{width:40px;height:40px;background:var(--gold-soft);border:none;border-radius:10px;display:flex;align-items:center;justify-content:center;margin-bottom:14px;flex-shrink:0;}' +
      '.nt-home-why-us-v1 .why-icon svg{width:18px;height:18px;stroke:var(--gold);fill:none;stroke-width:1.75;stroke-linecap:round;stroke-linejoin:round;}' +
      '.nt-home-why-us-v1 .why-card h4{font-family:var(--fb);font-size:13px;font-weight:600;color:var(--ink);margin-bottom:6px;line-height:1.3;}' +
      '.nt-home-why-us-v1 .why-card p{font-family:var(--fb);font-size:12px;color:var(--muted);line-height:1.6;}' +
      '.nt-home-why-us-v1 .why-card p span,.nt-home-why-us-v1 .sec-sub span{color:var(--gold);}' +
      '@media (max-width:880px){.nt-home-why-us-v1 .why-grid{grid-template-columns:repeat(2,1fr);gap:12px;}}' +
      '@media (max-width:520px){' +
      '.nt-home-why-us-v1 .sec-head{margin-bottom:28px;}' +
      '.nt-home-why-us-v1 .why-grid{grid-template-columns:repeat(2,1fr);gap:8px;}' +
      '.nt-home-why-us-v1 .why-card{padding:14px 12px;border-radius:10px;}' +
      '.nt-home-why-us-v1 .why-card-layout{flex-direction:row;align-items:center;gap:10px;}' +
      '.nt-home-why-us-v1 .why-icon{width:34px;height:34px;border-radius:8px;margin-bottom:0;}' +
      '.nt-home-why-us-v1 .why-icon svg{width:16px;height:16px;}' +
      '.nt-home-why-us-v1 .why-card-text{flex:1;min-width:0;}' +
      '.nt-home-why-us-v1 .why-card h4{font-size:12px;margin-bottom:2px;line-height:1.25;}' +
      '.nt-home-why-us-v1 .why-card p{font-size:11px;line-height:1.45;color:#9ca3af;}' +
      '}';
    document.head.appendChild(style);
  }

  function buildWhyUs() {
    injectWhyUsStyles();
    var cards = WHY_US_ITEMS.map(function (item) {
      return (
        '<div class="why-card">' +
        '<div class="why-card-layout">' +
        '<div class="why-icon">' + svg2(item.icon) + '</div>' +
        '<div class="why-card-text"><h4>' + esc(item.title) + '</h4><p>' + item.desc + '</p></div>' +
        '</div></div>'
      );
    }).join('');
    return (
      '<section class="section section-alt nt-home-why-us-v1"><div class="sec-head">' +
      '<span class="sec-label">Why Signs.inc</span>' +
      '<h2 class="sec-h"><em>Signs</em> Built Around You</h2>' +
      '<p class="sec-sub">Every detail is <span>yours to control</span>, from first sketch to final install.</p>' +
      '</div><div class="why-grid">' + cards + '</div></section>'
    );
  }

  function svg2(inner) {
    return '<svg viewBox="0 0 24 24">' + inner + '</svg>';
  }

  function buildPortfolio(cat) {
    var p = cat.portfolio;
    var baseItems =
      p.items ||
      cat.variants.items.map(function (item) {
        return { img: item.img, alt: item.alt, title: item.title, label: (item.title || '').split(' ')[0] };
      });
    var doubled = baseItems.concat(baseItems);
    var strip = doubled
      .map(function (item) {
        return (
          '<div class="cat-strip-item"><img src="' + item.img + '" alt="' + esc(item.alt || item.title) + '" loading="lazy">' +
          '<div class="cat-strip-cap"><small>' + esc(item.label) + '</small>' + esc(item.title) + '</div></div>'
        );
      })
      .join('');
    var portfolioLabel = cat.nameSub || p.label;
    var portfolioHeading = cat.nameMain ? heading(cat.nameMain, p.emphasis) : heading(p.heading, p.emphasis);
    return (
      '<section class="cat-portfolio"><div class="sec-head">' +
      '<span class="sec-label">' + esc(portfolioLabel) + '</span>' +
      '<h2 class="sec-h">' + portfolioHeading + '</h2></div>' +
      '<div class="cat-strip-wrap"><div class="cat-strip">' + strip + '</div></div>' +
      '<div class="cat-portfolio-link"><a href="/pages/portfolio">View Full Portfolio' + svg('arrowRight') + '</a></div>' +
      '</section>'
    );
  }

  function buildBestFor(cat) {
    var items = cat.bestFor.items
      .map(function (b) {
        return (
          '<div class="bestfor-card"><div class="bestfor-card-icon">' + svg(b.icon) + '</div>' +
          '<h4>' + esc(b.title) + '</h4><p>' + esc(b.desc) + '</p></div>'
        );
      })
      .join('');
    return (
      '<section class="cat-bestfor"><div class="sec-head">' +
      '<span class="sec-label">' + esc(cat.bestFor.label) + '</span>' +
      '<h2 class="sec-h">' + heading(cat.bestFor.heading, cat.bestFor.emphasis) + '</h2>' +
      '<p class="sec-sub">' + esc(cat.bestFor.sub) + '</p></div>' +
      '<div class="bestfor-grid">' + items + '</div></section>'
    );
  }

  function buildNotFound() {
    return (
      '<section class="cat-hero"><div class="cat-hero-inner">' +
      '<div class="cat-hero-text">' +
      '<h1>Sign Category Not Found</h1>' +
      '<p class="cat-hero-desc">We couldn\'t find that sign category. Browse the full list instead.</p>' +
      '<div class="cat-hero-ctas"><a href="/pages/sign-categories" class="btn-primary">Browse Sign Types' + svg('arrowRight') + '</a></div>' +
      '</div></div></section>'
    );
  }

  function buildDetailContent(slug) {
    var cat = DATA.CATEGORIES[slug];
    if (!cat) return buildNotFound();
    return (
      buildHero(cat) +
      buildVariants(cat) +
      buildWhyUs() +
      buildPortfolio(cat) +
      buildBestFor(cat)
    );
  }

  function updateMeta(slug) {
    var cat = DATA.CATEGORIES[slug];
    if (!cat) return;
    document.title = cat.breadcrumbLabel + ' | Signs.inc';
    var metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', cat.hero.desc);
  }

  function renderDetail(root, slug) {
    if (!root) return;
    root.innerHTML = buildDetailContent(slug);
    // .cat-page defaults to display:none (only .cat-page.active is shown) —
    // this page only ever renders one category, so it's always the active one.
    root.classList.add('active');
    if (DATA.CATEGORIES[slug]) {
      root.setAttribute('data-cat', slug);
      updateMeta(slug);
    }
  }

  // ───────────────────────── List page ─────────────────────────

  function buildListRow(slug, index) {
    var cat = DATA.CATEGORIES[slug];
    var row = cat.listRow;
    var reverse = index % 2 === 1 ? ' reverse' : '';
    var features = row.features
      .map(function (f) {
        return '<li>' + svg('check') + esc(f) + '</li>';
      })
      .join('');
    var titleHtml = cat.nameMain
      ? esc(cat.nameMain) + (cat.nameSub ? '<span class="type-row-title-sub">' + esc(cat.nameSub) + '</span>' : '')
      : esc(row.title);
    return (
      '<div class="type-row' + reverse + '">' +
      '<div class="type-row-img"><img src="' + row.image.src + '" alt="' + esc(row.image.alt) + '" loading="lazy"></div>' +
      '<div class="type-row-content">' +
      '<span class="sec-label">' + esc(row.badge) + '</span>' +
      '<h3>' + titleHtml + '</h3>' +
      '<p>' + esc(row.desc) + '</p>' +
      '<ul class="type-row-features">' + features + '</ul>' +
      '<a href="/pages/sign-category?cat=' + slug + '" class="type-row-btn">' + esc(row.ctaLabel) + svg('arrowRight') + '</a>' +
      '</div></div>'
    );
  }

  function buildListRowSkeleton(index) {
    var reverse = index % 2 === 1 ? ' reverse' : '';
    var featureLines = [1, 2, 3]
      .map(function () {
        return '<li class="skeleton-block" style="width:' + (60 + Math.random() * 30 | 0) + '%"></li>';
      })
      .join('');
    return (
      '<div class="type-row skeleton-row' + reverse + '">' +
      '<div class="type-row-img skeleton-block"></div>' +
      '<div class="type-row-content">' +
      '<span class="sec-label skeleton-block" style="width:110px;height:14px"></span>' +
      '<h3 class="skeleton-block" style="width:65%;height:30px;margin-top:14px"></h3>' +
      '<p class="skeleton-block" style="width:100%;height:56px;margin-top:12px"></p>' +
      '<ul class="type-row-features" style="margin-top:14px">' + featureLines + '</ul>' +
      '<span class="type-row-btn skeleton-block" style="width:170px;height:46px;margin-top:18px"></span>' +
      '</div></div>'
    );
  }

  function renderListSkeleton(root) {
    var rows = DATA.ORDER.map(function (slug, i) {
      return buildListRowSkeleton(i);
    }).join('');
    root.innerHTML = '<section class="types-list types-list-skeleton">' + rows + '</section>';
  }

  function renderList(root) {
    if (!root) return;

    injectSkeletonStyles();
    renderListSkeleton(root);

    var rowsHtml = DATA.ORDER.map(function (slug, i) {
      return buildListRow(slug, i);
    }).join('');

    var imageSrcs = DATA.ORDER.map(function (slug) {
      return DATA.CATEGORIES[slug].listRow.image.src;
    });

    // Wait for the real images to be ready (max 4s), AND for a minimum
    // display time, so the skeleton is always visible for a beat instead of
    // flashing away instantly on fast/cached loads.
    var MIN_SKELETON_MS = 600;
    Promise.all([
      preloadImagesWithTimeout(imageSrcs, 4000),
      wait(MIN_SKELETON_MS),
    ]).then(function () {
      root.innerHTML = '<section class="types-list">' + rowsHtml + '</section>';
    });
  }

  // ───────────────────────── Shared interactions ─────────────────────────

  function initInteractions() {
    var varGalleryModal = document.getElementById('varGalleryModal');
    var varGalleryTitle = document.getElementById('varGalleryTitle');
    var varGalleryGrid = document.getElementById('varGalleryGrid');
    var varGalleryClose = document.getElementById('varGalleryClose');
    var varGalleryBackdrop = document.getElementById('varGalleryBackdrop');

    var quotePopupModal = document.getElementById('quotePopupModal');
    var quotePopupFormWrap = document.getElementById('quotePopupFormWrap');
    var quotePopupThanks = document.getElementById('quotePopupThanks');
    var quotePopupForm = document.getElementById('quotePopupForm');
    var quotePopupSignType = document.getElementById('quotePopupSignType');
    var quotePopupClose = document.getElementById('quotePopupClose');
    var quotePopupBackdrop = document.getElementById('quotePopupBackdrop');
    var quotePopupDone = document.getElementById('quotePopupDone');
    var qpLogo = document.getElementById('qp-logo');
    var qpFileName = document.getElementById('qp-file-name');
    var qpFileWrap = document.getElementById('qpFileWrap');
    var qpFileClear = document.getElementById('qpFileClear');
    var qpFileList = document.getElementById('qpFileList');
    var qpUploadProgress = document.getElementById('qpUploadProgress');
    var qpUploadProgressBar = document.getElementById('qpUploadProgressBar');
    var qpUploadProgressLabel = document.getElementById('qpUploadProgressLabel');
    var qpDefaultFileNameText = qpFileName ? qpFileName.textContent : '';

    if (!varGalleryModal && !quotePopupModal) return; // list page has neither

    // ── Leads API config ──
    var LEADS_API_URL = 'https://submissions.signs.inc/api/leads';
    var IMAGE_UPLOAD_URL = 'https://imagescloudv2.codeblue.agency/api/image/upload';

    // Fallback: if imagescloud upload fails, upload the file directly to
    // Cloudinary instead (with its own live progress bar, labeled "Cloud
    // uploading" so it's obvious which provider actually served the request)
    // and use that URL in the lead payload.
    var CLOUDINARY_UPLOAD_URL = 'https://api.cloudinary.com/v1_1/hkhkjjar/image/upload';
    function generateCloudinaryPublicId(nameInput, uuid) {
      var cleanName = String(nameInput || 'file').trim().replace(/[^a-z0-9_\-]/gi, '_').toLowerCase() || 'file';
      return cleanName + '_' + Date.now() + '_' + uuid;
    }
    function uploadOneFileToCloudinaryWithProgress(entry) {
      return new Promise(function (resolve) {
        var cloudFd = new FormData();
        cloudFd.append('file', entry.file);
        cloudFd.append('upload_preset', 'imageupload');
        cloudFd.append('cloud_name', 'hkhkjjar');
        cloudFd.append('public_id', generateCloudinaryPublicId((document.getElementById('qp-name') || {}).value, leadUuid));

        if (qpUploadProgressBar) qpUploadProgressBar.style.width = '0%';
        if (qpUploadProgressLabel) qpUploadProgressLabel.textContent = 'Cloud uploading… 0%';

        var cxhr = new XMLHttpRequest();
        cxhr.upload.onprogress = function (e) {
          if (!e.lengthComputable) return;
          var pct = Math.round((e.loaded / e.total) * 100);
          if (qpUploadProgressBar) qpUploadProgressBar.style.width = pct + '%';
          if (qpUploadProgressLabel) qpUploadProgressLabel.textContent = 'Cloud uploading… ' + pct + '%';
        };
        cxhr.onload = function () {
          if (cxhr.status >= 200 && cxhr.status < 300) {
            try {
              var data = JSON.parse(cxhr.responseText);
              if (data && data.secure_url) {
                entry.status = 'done';
                entry.url = data.secure_url;
                resolve();
                return;
              }
            } catch (e) {
              // fall through to failure handling below
            }
          }
          console.error('Cloudinary fallback upload failed:', cxhr.status, cxhr.responseText);
          entry.status = 'error';
          resolve();
        };
        cxhr.onerror = function () {
          console.error('Cloudinary fallback upload failed (network).');
          entry.status = 'error';
          resolve();
        };
        cxhr.open('POST', CLOUDINARY_UPLOAD_URL, true);
        cxhr.send(cloudFd);
      });
    }
    // Continuing a batch whose isUploadingLogo=true already happened in
    // uploadQuotePopupLogo — this owns turning it back off at the end,
    // not another toggle-on.
    function uploadFallbackToCloudinary(entries) {
      entries.forEach(function (entry) { entry.status = 'cloud-uploading'; });
      renderQpFileList();
      var i = 0;
      function next() {
        if (i >= entries.length) {
          isUploadingLogo = false;
          updateQpSubmitDisabled();
          if (qpUploadProgress) qpUploadProgress.classList.remove('active');
          updateUploadedImageUrls();
          renderQpFileList();
          if (typeof scheduleProspectSync === 'function') scheduleProspectSync();
          return;
        }
        uploadOneFileToCloudinaryWithProgress(entries[i]).then(function () {
          i++;
          next();
        });
      }
      next();
    }

    function makeUuid() {
      return window.crypto && window.crypto.randomUUID
        ? window.crypto.randomUUID()
        : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = (Math.random() * 16) | 0;
          return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
        });
    }

    var currentSignType = '';
    function getCurrentCategoryName() {
      var root = document.getElementById('sign-category-root');
      var slug =
        new URLSearchParams(window.location.search).get('cat') ||
        (root && root.getAttribute('data-cat'));
      if (!slug) return '';
      var cat = DATA.CATEGORIES[slug];
      // Always send *something* for a present ?cat= — the slug itself if no
      // data entry/name matches, so category is never silently empty.
      if (!cat) return slug;
      return cat.nameMain || cat.breadcrumbLabel || (cat.listRow && cat.listRow.title) || slug;
    }
    var leadUuid = makeUuid();
    var uploadedImageUrls = [];
    var isUploadingLogo = false;
    var qpFiles = []; // { file, status: 'pending'|'uploading'|'done'|'error', url }

    function escFileName(s) {
      return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
    function syncQpInputFiles() {
      var dt = new DataTransfer();
      qpFiles.forEach(function (entry) { dt.items.add(entry.file); });
      qpLogo.files = dt.files;
    }
    function updateUploadedImageUrls() {
      uploadedImageUrls = qpFiles
        .filter(function (e) { return e.status === 'done' && e.url; })
        .map(function (e) { return e.url; });
    }
    function renderQpFileList() {
      if (!qpFiles.length) {
        if (qpFileWrap) qpFileWrap.classList.remove('has-file');
        if (qpFileName) qpFileName.textContent = qpDefaultFileNameText;
        if (qpFileList) qpFileList.innerHTML = '';
        return;
      }
      if (qpFileWrap) qpFileWrap.classList.add('has-file');
      if (qpFileName) qpFileName.textContent = qpFiles.length === 1 ? qpFiles[0].file.name : qpFiles.length + ' files selected';
      if (qpFileList) {
        qpFileList.innerHTML = qpFiles
          .map(function (entry, i) {
            var statusClass = entry.status === 'done' ? 'ok' : entry.status === 'error' ? 'err' : '';
            var statusText =
              entry.status === 'cloud-uploading' ? 'Cloud uploading…' :
              entry.status === 'uploading' ? 'Uploading…' :
              entry.status === 'done' ? 'Ready' :
              entry.status === 'error' ? 'Failed' : 'Pending';
            return (
              '<div class="qf-file-item">' +
              '<span class="qf-file-item-name">' + escFileName(entry.file.name) + '</span>' +
              '<span class="qf-file-item-status ' + statusClass + '">' + statusText + '</span>' +
              '<button type="button" class="qf-file-item-remove" data-remove-idx="' + i + '" aria-label="Remove file">' +
              '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
              '</button>' +
              '</div>'
            );
          })
          .join('');
      }
    }
    function uploadQuotePopupLogo(files) {
      var pending = files.filter(function (e) { return e.status === 'pending' || e.status === 'error'; });
      if (!pending.length) return;
      pending.forEach(function (e) { e.status = 'uploading'; });
      isUploadingLogo = true;
      updateQpSubmitDisabled();
      renderQpFileList();
      if (qpUploadProgress) qpUploadProgress.classList.add('active');
      if (qpUploadProgressBar) qpUploadProgressBar.style.width = '0%';
      if (qpUploadProgressLabel) qpUploadProgressLabel.textContent = 'Uploading… 0%';

      var fd = new FormData();
      fd.append('name', (document.getElementById('qp-name') || {}).value || 'lead');
      fd.append('page_url', window.location.href);
      fd.append('uuid', leadUuid);
      pending.forEach(function (entry) { fd.append('images[]', entry.file); });

      // imagescloud failed — fall straight to the Cloudinary fallback (no retry
      // wait) so the visitor sees the "Cloud uploading" progress bar right away.
      function finishFailure() {
        uploadFallbackToCloudinary(pending);
      }

      var xhr = new XMLHttpRequest();
      xhr.upload.onprogress = function (e) {
        if (!e.lengthComputable) return;
        var pct = Math.round((e.loaded / e.total) * 100);
        if (qpUploadProgressBar) qpUploadProgressBar.style.width = pct + '%';
        if (qpUploadProgressLabel) qpUploadProgressLabel.textContent = 'Uploading… ' + pct + '%';
      };
      xhr.onload = function () {
        if (xhr.status < 200 || xhr.status >= 300) {
          console.error('Logo upload failed:', xhr.responseText);
          finishFailure();
          return;
        }
        var urls = [];
        try {
          var data = JSON.parse(xhr.responseText);
          urls = (data && data.imageUrls) || [];
        } catch (e) {
          console.error('Invalid response from upload server');
        }
        pending.forEach(function (entry, i) {
          if (urls[i]) {
            entry.status = 'done';
            entry.url = urls[i];
          }
        });
        updateUploadedImageUrls();
        renderQpFileList();
        if (typeof scheduleProspectSync === 'function') scheduleProspectSync();
        var failed = pending.filter(function (e) { return e.status !== 'done'; });
        if (failed.length) {
          // Hand off to the Cloudinary fallback — it owns the final isUploadingLogo toggle-off.
          uploadFallbackToCloudinary(failed);
        } else {
          isUploadingLogo = false;
          updateQpSubmitDisabled();
          if (qpUploadProgress) qpUploadProgress.classList.remove('active');
        }
      };
      xhr.onerror = function () { finishFailure(); };
      xhr.open('POST', IMAGE_UPLOAD_URL, true);
      xhr.send(fd);
    }

    function waitForQuotePopupUpload() {
      return new Promise(function (resolve) {
        if (!isUploadingLogo) { resolve(); return; }
        var iv = setInterval(function () {
          if (!isUploadingLogo) { clearInterval(iv); resolve(); }
        }, 200);
      });
    }

    // Keeps the "Submit" button disabled for as long as a logo/reference
    // file is still uploading, so a lead can't be submitted mid-upload.
    function updateQpSubmitDisabled() {
      var submitBtn = quotePopupForm && quotePopupForm.querySelector('.qf-submit');
      if (submitBtn) submitBtn.disabled = isUploadingLogo;
    }

    function lockBodyScroll() {
      document.body.style.overflow = 'hidden';
    }
    function unlockBodyScroll() {
      var galleryOpen = varGalleryModal && varGalleryModal.classList.contains('open');
      var quoteOpen = quotePopupModal && quotePopupModal.classList.contains('open');
      if (!galleryOpen && !quoteOpen) document.body.style.overflow = '';
    }

    function openVarGallery(card) {
      var title = (card.querySelector('h3') || {}).textContent || '';
      title = title.trim();
      var fallback = (card.querySelector('.var-card-img img') || {}).src;
      var galleryRoot = document.getElementById('sign-category-root');
      var gallerySlug =
        new URLSearchParams(window.location.search).get('cat') ||
        (galleryRoot && galleryRoot.getAttribute('data-cat'));
      var images =
        (DATA.galleryFor && DATA.galleryFor(gallerySlug, normalizeSignName(title), fallback)) ||
        DATA.GALLERY_SETS[normalizeSignName(title)] ||
        (fallback ? [fallback] : []);
      varGalleryTitle.textContent = title;
      varGalleryGrid.innerHTML = images
        .map(function (src) {
          return '<img src="' + src + '" alt="' + esc(title) + '" loading="lazy">';
        })
        .join('');
      varGalleryModal.classList.add('open');
      varGalleryModal.setAttribute('aria-hidden', 'false');
      lockBodyScroll();
    }

    function closeVarGallery() {
      varGalleryModal.classList.remove('open');
      varGalleryModal.setAttribute('aria-hidden', 'true');
      unlockBodyScroll();
      varGalleryGrid.innerHTML = '';
    }

    function qpResetFieldStates() {
      qpPhonePrevLen = 0;
      [document.getElementById('qp-name'), document.getElementById('qp-email'), document.getElementById('qp-phone')].forEach(
        function (el) {
          if (el) el.classList.remove('valid', 'err');
        }
      );
      [
        document.getElementById('qp-help-name'),
        document.getElementById('qp-help-email'),
        document.getElementById('qp-help-phone'),
        document.getElementById('qp-help-logo'),
      ].forEach(function (el) {
        if (el) {
          el.classList.remove('err');
          el.textContent = '';
        }
      });
    }

    function openQuotePopup(signType) {
      quotePopupForm.reset();
      qpResetFieldStates();
      currentSignType = signType || '';
      leadUuid = makeUuid();
      uploadedImageUrls = [];
      qpFiles = [];
      syncQpInputFiles();
      renderQpFileList();
      // Fresh popup instance — start a brand-new prospect audit trail.
      if (typeof prospectUuid !== 'undefined') {
        prospectUuid = makeUuid();
        prospectCreated = false;
        prospectLastPayloadStr = null;
        prospectFinalized = false;
        prospectAirtableId = null;
        clearTimeout(prospectInputTimer);
      }
      if (quotePopupSignType) {
        quotePopupSignType.innerHTML = signType ? 'Sign type: <strong>' + esc(signType) + '</strong>' : '';
      }
      var details = document.getElementById('qp-details');
      if (details && signType) details.placeholder = 'Tell us about your ' + signType + ' project — size, colors, timeline...';
      quotePopupFormWrap.hidden = false;
      quotePopupThanks.hidden = true;
      quotePopupModal.classList.add('open');
      quotePopupModal.setAttribute('aria-hidden', 'false');
      lockBodyScroll();
      setTimeout(function () {
        var nameField = document.getElementById('qp-name');
        if (nameField) nameField.focus();
      }, 120);
    }

    function closeQuotePopup() {
      quotePopupModal.classList.remove('open');
      quotePopupModal.setAttribute('aria-hidden', 'true');
      unlockBodyScroll();
      setTimeout(function () {
        quotePopupFormWrap.hidden = false;
        quotePopupThanks.hidden = true;
        quotePopupForm.reset();
        qpResetFieldStates();
        qpFiles = [];
        syncQpInputFiles();
        renderQpFileList();
      }, 280);
    }

    if (varGalleryClose) varGalleryClose.addEventListener('click', closeVarGallery);
    if (varGalleryBackdrop) varGalleryBackdrop.addEventListener('click', closeVarGallery);
    if (quotePopupClose) quotePopupClose.addEventListener('click', closeQuotePopup);
    if (quotePopupBackdrop) quotePopupBackdrop.addEventListener('click', closeQuotePopup);
    if (quotePopupDone) quotePopupDone.addEventListener('click', closeQuotePopup);

    var ALLOWED_EXTENSIONS = ['png', 'jpg', 'jpeg', 'svg', 'pdf', 'webp', 'ai', 'eps', 'psd'];
    function getFileExtension(filename) {
      if (!filename || typeof filename !== 'string') return '';
      var parts = filename.split('.');
      if (parts.length < 2) return '';
      return parts.pop().toLowerCase();
    }
    function isAllowedFileType(file) {
      if (!file) return false;
      var ext = getFileExtension(file.name);
      return ALLOWED_EXTENSIONS.indexOf(ext) !== -1;
    }

    var qpHelpLogo = document.getElementById('qp-help-logo');
    var MAX_QP_LOGO_SIZE = 20 * 1024 * 1024;
    if (qpLogo && qpFileName) {
      qpLogo.addEventListener('change', function () {
        var incoming = qpLogo.files ? Array.prototype.slice.call(qpLogo.files) : [];
        if (!incoming.length) return;
        var invalidType = incoming.filter(function (f) { return !isAllowedFileType(f); })[0];
        if (invalidType) {
          syncQpInputFiles();
          var ext = getFileExtension(invalidType.name).toUpperCase();
          if (qpHelpLogo) {
            qpHelpLogo.classList.add('err');
            qpHelpLogo.textContent = 'Invalid format (' + (ext ? '.' + ext : 'unsupported') + ') — please upload PNG, JPG, SVG, WEBP, PDF, AI, EPS, or PSD.';
          }
          if (qpFileWrap) qpFileWrap.classList.add('err');
          return;
        }
        var oversized = incoming.filter(function (f) { return f.size > MAX_QP_LOGO_SIZE; })[0];
        if (oversized) {
          syncQpInputFiles();
          if (qpHelpLogo) {
            qpHelpLogo.classList.add('err');
            qpHelpLogo.textContent = '"' + oversized.name + '" exceeds 20 MB — please choose a smaller file.';
          }
          if (qpFileWrap) qpFileWrap.classList.add('err');
          return;
        }
        if (qpHelpLogo) { qpHelpLogo.classList.remove('err'); qpHelpLogo.textContent = ''; }
        if (qpFileWrap) qpFileWrap.classList.remove('err');
        incoming.forEach(function (f) {
          if (!isAllowedFileType(f)) return;
          var dup = qpFiles.some(function (e) {
            return e.file.name === f.name && e.file.size === f.size && e.file.lastModified === f.lastModified;
          });
          if (!dup) {
            qpFiles.push({ file: f, status: 'pending', url: '' });
          }
        });
        syncQpInputFiles();
        renderQpFileList();
        uploadQuotePopupLogo(qpFiles);
      });
    }

    if (qpFileList) {
      qpFileList.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-remove-idx]');
        if (!btn) return;
        var idx = parseInt(btn.getAttribute('data-remove-idx'), 10);
        qpFiles.splice(idx, 1);
        syncQpInputFiles();
        updateUploadedImageUrls();
        renderQpFileList();
        updateQpSubmitDisabled();
      });
    }

    if (qpFileClear) {
      qpFileClear.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        qpFiles = [];
        uploadedImageUrls = [];
        syncQpInputFiles();
        renderQpFileList();
        updateQpSubmitDisabled();
        if (qpHelpLogo) { qpHelpLogo.classList.remove('err'); qpHelpLogo.textContent = ''; }
      });
    }

    var qpIsName = function (v) { return v.trim().length >= 2; };
    var qpIsEmail = function (v) {
      return /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(v.trim());
    };
    var qpIsPhone = function (v) {
      var digits = v.replace(/\D/g, '');
      return digits.length === 11 && digits.startsWith('1');
    };

    var qpName = document.getElementById('qp-name');
    var qpEmail = document.getElementById('qp-email');
    var qpPhone = document.getElementById('qp-phone');
    var qpHelpName = document.getElementById('qp-help-name');
    var qpHelpEmail = document.getElementById('qp-help-email');
    var qpHelpPhone = document.getElementById('qp-help-phone');

    // Inline errors — this form lives inside a transformed/scrolling modal dialog,
    // where browsers silently refuse to render the native reportValidity() tooltip.
    function qpValidateLive(which) {
      if (which === 'name' && qpName && qpHelpName) {
        var okN = qpIsName(qpName.value);
        qpName.classList.toggle('valid', okN);
        qpName.classList.toggle('err', !okN && qpName.value.trim().length > 0);
        qpHelpName.classList.remove('err');
        qpHelpName.textContent = '';
      }
      if (which === 'email' && qpEmail && qpHelpEmail) {
        var okE = qpIsEmail(qpEmail.value);
        qpEmail.classList.toggle('valid', okE);
        qpEmail.classList.toggle('err', !okE && qpEmail.value.trim().length > 3);
        if (!okE && qpEmail.value.trim().length > 3) {
          qpHelpEmail.classList.add('err');
          qpHelpEmail.textContent = 'Please enter a valid email address.';
        } else {
          qpHelpEmail.classList.remove('err');
          qpHelpEmail.textContent = '';
        }
      }
      if (which === 'phone' && qpPhone && qpHelpPhone) {
        var okP = qpIsPhone(qpPhone.value);
        qpPhone.classList.toggle('valid', okP);
        qpPhone.classList.toggle('err', !okP && qpPhone.value.trim().length > 0);
        if (!okP && qpPhone.value.trim().length > 0) {
          qpHelpPhone.classList.add('err');
          qpHelpPhone.textContent = 'Please enter a valid 10-digit phone number.';
        } else {
          qpHelpPhone.classList.remove('err');
          qpHelpPhone.textContent = '';
        }
      }
    }
    if (qpName) qpName.addEventListener('input', function () { qpValidateLive('name'); });
    if (qpEmail) qpEmail.addEventListener('input', function () { qpValidateLive('email'); });
    // qpPhonePrevLen tracks how many real digits were on screen before this
    // keystroke — the displayed "+1" prefix itself contributes a leading "1"
    // once there's at least one real digit, and that phantom "1" must be
    // stripped out of the re-parsed digit string on every subsequent edit.
    // But on the very first keystroke into an empty field there is no "+1"
    // prefix yet, so a genuine leading "1" typed by the user must NOT be
    // stripped (otherwise it's silently swallowed).
    var qpPhonePrevLen = 0;
    if (qpPhone) {
      qpPhone.addEventListener('input', function (e) {
        var val = qpPhone.value;
        var raw = val.replace(/\D/g, '');
        if (raw.startsWith('1')) {
          if (val.startsWith('+1') || raw.length > 10) {
            raw = raw.slice(1);
          } else if (raw === '1') {
            if (e && e.inputType && e.inputType.startsWith('delete')) {
              qpPhone.value = '';
              qpValidateLive('phone');
              return;
            }
            raw = '';
          }
        }
        var d = raw.slice(0, 10);
        qpPhonePrevLen = d.length;
        var out = '';
        if (d.length > 0 || (val.startsWith('1') && raw === '')) {
          out = '+1 ';
          if (d.length > 6) {
            out += '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6);
          } else if (d.length > 3) {
            out += '(' + d.slice(0, 3) + ') ' + d.slice(3);
          } else if (d.length > 0) {
            out += '(' + d;
          }
        }
        qpPhone.value = out;
        qpValidateLive('phone');
      });
    }

    if (quotePopupForm) {
      quotePopupForm.addEventListener('submit', function (e) {
        e.preventDefault();

        var nameI = qpName;
        var emailI = qpEmail;
        var phoneI = qpPhone;
        var detailsI = document.getElementById('qp-details');

        var name = nameI ? nameI.value.trim() : '';
        var email = emailI ? emailI.value.trim() : '';
        var phone = phoneI ? phoneI.value.trim() : '';

        qpValidateLive('name');
        qpValidateLive('email');
        qpValidateLive('phone');

        var nameOk = qpIsName(name);
        var emailOk = qpIsEmail(email);
        var phoneOk = qpIsPhone(phone);

        var firstInvalid = null;
        if (!nameOk) {
          if (nameI) nameI.classList.add('err');
          if (qpHelpName) {
            qpHelpName.classList.add('err');
            qpHelpName.textContent = name ? 'Please enter your full name.' : 'Please enter your name.';
          }
          firstInvalid = firstInvalid || nameI;
        }
        if (!emailOk) {
          if (emailI) emailI.classList.add('err');
          if (qpHelpEmail) {
            qpHelpEmail.classList.add('err');
            qpHelpEmail.textContent = email ? 'Please enter a valid email address.' : 'Please enter your email address.';
          }
          firstInvalid = firstInvalid || emailI;
        }
        if (!phoneOk) {
          if (phoneI) phoneI.classList.add('err');
          if (qpHelpPhone) {
            qpHelpPhone.classList.add('err');
            qpHelpPhone.textContent = phone ? 'Please enter a valid 10-digit phone number.' : 'Please enter your phone number.';
          }
          firstInvalid = firstInvalid || phoneI;
        }

        var logoOk = !!(qpLogo && qpLogo.files && qpLogo.files[0]);
        if (!logoOk) {
          if (qpHelpLogo) {
            qpHelpLogo.classList.add('err');
            qpHelpLogo.textContent = 'Please upload a logo or artwork file.';
          }
          firstInvalid = firstInvalid || qpLogo;
        }

        if (firstInvalid) {
          firstInvalid.focus();
          return;
        }

        var submitBtn = quotePopupForm.querySelector('.qf-submit');
        var origLabel = submitBtn ? submitBtn.innerHTML : '';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.innerHTML = 'Sending…';
        }

        function showQuotePopupThanks() {
          prospectFinalized = true;
          clearTimeout(prospectInputTimer);
          var nmOut = document.getElementById('qpThanksName');
          var emOut = document.getElementById('qpThanksEmail');
          var phOut = document.getElementById('qpThanksPhone');
          if (nmOut) nmOut.textContent = name || '—';
          if (emOut) emOut.textContent = email || '—';
          if (phOut) phOut.textContent = phone || '—';
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.innerHTML = origLabel;
          }
          quotePopupFormWrap.hidden = true;
          quotePopupThanks.hidden = false;
        }

        (isUploadingLogo ? waitForQuotePopupUpload() : Promise.resolve())
          .then(function () {
            let leadSource = (window.safeSessionStorage||sessionStorage).getItem('currentURL');
            var payload = {
              uuid: leadUuid,
              name: name,
              phone: phone,
              email: email,
              business_website: '',
              details: detailsI ? detailsI.value.trim() : '',
              estimated_size: '',
              sign_placement: '',
              signtypes: currentSignType ? [currentSignType] : [],
              category: getCurrentCategoryName(),
              images: uploadedImageUrls,
              lead_page_url: window.location.href,
              first_click: (window.safeLocalStorage||localStorage).getItem('first_click') || '',
              first_visit: (window.safeLocalStorage||localStorage).getItem('first_visit') || '',
              visit_count: (window.safeLocalStorage||localStorage).getItem('visit_count') || '',
              event_source: (window.safeLocalStorage||localStorage).getItem('event_keys_data') || '',
              location: (window.safeLocalStorage||localStorage).getItem('location'),
              record_source: "Collection Page Categories",
              lead_source: leadSource || '-',
              tracking_metadata:
                typeof window.getLeadTrackingData === 'function' ? window.getLeadTrackingData() : {},
              ProspectAirtableID: prospectAirtableId,
            };

            return fetch(LEADS_API_URL, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(payload),
            });
          })
          .then(function (res) {
            if (!res.ok) throw new Error('Request failed with status ' + res.status);

            try {
              if (typeof gtag_report_conversion === 'function') {
                gtag_report_conversion();
              }
            } catch (err) {
              console.error('Error during gtag_report_conversion:', err);
            }
            window.history.pushState({}, '', window.location.pathname + '?thanks-for-response');
            showQuotePopupThanks();
          })
          .catch(function (err) {
            console.error('Lead submission failed:', err);
            window.history.pushState({}, '', window.location.pathname + '?thanks-for-submission');
            if (typeof window.logClientError === 'function') {
              window.logClientError('sign_categories_v1_quote_popup', err, leadUuid);
            }
            showQuotePopupThanks();
          });
      });
    }

    // ══════════ PROSPECT LEAD — independent audit trail ══════════
    // Captures whatever the visitor has typed into the quote popup even if they
    // never hit Submit. Fires on tab-hide and page teardown — separate uuid + API
    // from the /api/leads flow above.
    var PROSPECTS_API_URL = 'https://submissions.signs.inc/api/prospects';
    // Fresh identity every page load (not persisted) — closing the tab, refreshing,
    // or reopening the link in a new tab must start a brand-new prospect lead
    // rather than resuming/patching the previous one.
    var prospectUuid = makeUuid();
    var prospectCreated = false;
    var prospectLastPayloadStr = null;
    var prospectFinalized = false;
    var prospectAirtableId = null;

    function buildProspectPayload() {
      var detailsI2 = document.getElementById('qp-details');
      var leadSource2 = (window.safeSessionStorage||sessionStorage).getItem('currentURL');
      return {
        uuid: prospectUuid,
        name: qpName ? qpName.value.trim() : '',
        phone: qpPhone ? qpPhone.value.trim() : '',
        email: qpEmail ? qpEmail.value.trim() : '',
        business_website: '',
        details: detailsI2 ? detailsI2.value.trim() : '',
        estimated_size: '',
        sign_placement: '',
        signtypes: currentSignType ? [currentSignType] : [],
        category: getCurrentCategoryName(),
        images: uploadedImageUrls,
        lead_page_url: window.location.href,
        first_click: (window.safeLocalStorage||localStorage).getItem('first_click') || '',
        first_visit: (window.safeLocalStorage||localStorage).getItem('first_visit') || '',
        visit_count: (window.safeLocalStorage||localStorage).getItem('visit_count') || '',
        event_source: (window.safeLocalStorage||localStorage).getItem('event_keys_data') || '',
        location: (window.safeLocalStorage||localStorage).getItem('location'),
        record_source: 'Collection Page Categories',
        lead_source: leadSource2 || '-',
        tracking_metadata: typeof window.getLeadTrackingData === 'function' ? window.getLeadTrackingData() : {},
      };
    }

    function hasProspectData(payload) {
      var filled = ['name', 'phone', 'email', 'business_website', 'details'].some(function (k) {
        return payload[k] && String(payload[k]).trim();
      });
      return filled || payload.signtypes.length > 0 || payload.images.length > 0;
    }

    function syncProspect() {
      if (prospectFinalized) return;
      if (!quotePopupModal || !quotePopupModal.classList.contains('open')) return;
      if (isUploadingLogo) return; // wait for the upload to finish so the URL is included
      var payload = buildProspectPayload();
      if (!hasProspectData(payload)) return;
      var str = JSON.stringify(payload);
      if (str === prospectLastPayloadStr) return; // nothing changed since last sync
      prospectLastPayloadStr = str;

      var isFirst = !prospectCreated;
      var url = isFirst ? PROSPECTS_API_URL : PROSPECTS_API_URL + '/' + encodeURIComponent(prospectUuid);
      if (isFirst) {
        prospectCreated = true;
      }
      fetch(url, {
        method: isFirst ? 'POST' : 'PATCH',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: str,
        keepalive: true,
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          if (data && data.airtableRecordId) prospectAirtableId = data.airtableRecordId;
        })
        .catch(function (err) {
          console.warn('Prospect sync failed:', err);
        });
    }

    // Creation happens as soon as the visitor types anything in the popup
    // (debounced), not on tab-switch. Tab-switch only PATCHes an already-created
    // prospect. Closing the tab / refreshing only fires a CREATE fallback if
    // nothing was created yet — it never PATCHes on close.
    var prospectInputTimer = null;
    function scheduleProspectSync() {
      clearTimeout(prospectInputTimer);
      prospectInputTimer = setTimeout(syncProspect, 700);
    }
    if (quotePopupForm) {
      quotePopupForm.addEventListener('input', scheduleProspectSync);
      quotePopupForm.addEventListener('change', scheduleProspectSync);
    }

    // NOTE: intentionally not listening to window 'blur' — it also fires when
    // focus shifts to DevTools or the address bar, not just on a real tab switch.
    // 'visibilitychange' (document.hidden) is the reliable "user left the tab" signal.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden && prospectCreated) syncProspect();
    });
    window.addEventListener('pagehide', function () {
      if (!prospectCreated) syncProspect();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (varGalleryModal && varGalleryModal.classList.contains('open')) closeVarGallery();
      if (quotePopupModal && quotePopupModal.classList.contains('open')) closeQuotePopup();
    });

    document.addEventListener('click', function (e) {
      var galleryBtn = e.target.closest('.var-card-gallery');
      if (galleryBtn) {
        e.preventDefault();
        var gCard = galleryBtn.closest('.var-card');
        if (gCard) openVarGallery(gCard);
        return;
      }
      var varCard = e.target.closest('.var-card');
      if (varCard) {
        e.preventDefault();
        var title = (varCard.querySelector('h3') || {}).textContent;
        openQuotePopup(title ? title.trim() : '');
        return;
      }
      var filterBtn = e.target.closest('.cat-var-filter');
      if (filterBtn) {
        var section = filterBtn.closest('.cat-variants');
        if (!section) return;
        var filter = filterBtn.getAttribute('data-filter');
        section.querySelectorAll('.cat-var-filter').forEach(function (b) {
          b.classList.remove('active');
        });
        filterBtn.classList.add('active');
        section.querySelectorAll('.var-card[data-placement]').forEach(function (card) {
          if (filter === 'all') {
            card.classList.remove('hidden');
            return;
          }
          var placements = card.getAttribute('data-placement').split(' ');
          card.classList.toggle('hidden', placements.indexOf(filter) === -1);
        });
      }
    });
  }

  window.SignCategoriesUI = {
    renderList: renderList,
    renderDetail: renderDetail,
    initInteractions: initInteractions,
  };
})();